import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
    return (
        <div className="relative min-h-[85vh] w-full bg-gray-900 flex items-center">
            {/* Background Image */}
            <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-60"
                style={{ backgroundImage: "url('/assets/elevations.png')" }}
            ></div>

            {/* Overlay Gradient */}
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-transparent"></div>

            {/* Content */}
            <div className="relative w-full container mx-auto px-4 text-white pt-24 pb-10 md:py-0">
                <div className="max-w-2xl animate-fade-in-up">
                    <div className="inline-block bg-white p-6 rounded-full mb-8 shadow-lg">
                        <div className="relative">
                            <img
                                src="/assets/logo/jclogo.png"
                                alt="Joshi Construction Logo"
                                className="h-32 md:h-40 w-auto"
                            />
                            <span className="absolute top-1 right-1 text-lg text-gray-800 font-bold">®</span>
                        </div>
                    </div>

                    <p className="text-primary font-semibold text-lg mb-4 tracking-wide uppercase">
                        15 Years of Excellence in Construction
                    </p>
                    <h1 className="text-5xl md:text-6xl font-bold leading-tight mb-6">
                        Building Dreams <br />
                        <span className="text-primary">into Reality</span>
                    </h1>
                    <p className="text-xl text-gray-200 mb-8 max-w-lg">
                        We specialize in creating premium residential and commercial spaces that stand the test of time.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4">
                        <Link
                            to="/gallery"
                            className="px-8 py-3 bg-primary hover:bg-orange-700 text-white font-bold rounded-md transition-all duration-300 flex items-center justify-center"
                        >
                            View Gallery
                            <ArrowRight size={20} className="ml-2" />
                        </Link>
                        <Link
                            to="/about"
                            className="px-8 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white font-bold rounded-md transition-all duration-300 flex items-center justify-center"
                        >
                            About Us
                        </Link>
                        <Link
                            to="/contact"
                            className="px-8 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white font-bold rounded-md transition-all duration-300 flex items-center justify-center"
                        >
                            Contact Us
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;
